import fetchShowroomApi from "../utils/fetch-showroom-api";

customElements.component = 'showroom-quiz';

if (!customElements.get(customElements.component)) {
  const selectors = {
    html: "html",
    prevButton: ".js-showroom-quiz-prev",
    nextButton: ".js-showroom-quiz-next",
    progressBar: ".js-showroom-quiz-progress",
    steps: ".js-showroom-quiz-step",
    currentStepEl: ".js-showroom-quiz-current-step",
    step1Items: ".js-showroom-quiz__image",
    step2Items: ".js-showroom-quiz__count",
    brideNameInput: ".js-bride-name",
    datePickerValue: ".js-date-picker-value",
    createButton: ".js-showroom-quiz-create",
    cancelModal: ".js-cancel-modal",
    cancelModalTrigger: ".js-cancel-modal-trigger",
    cancelModalSubmit: ".js-cancel-modal-submit",
    modal: ".js-modal",
    modalInner: ".js-modal-inner",
    modalClose: ".js-modal-close",
    hidden: "hidden",
    disabled: "disabled"
  }

  class ShowroomQuiz extends HTMLElement {
    constructor() {
      super();

      this.currentStep = 1;
      this.stepsCount = window.showroomQuizStepsCount;
      this.html = document.querySelector(selectors.html);
      this.steps = this.querySelectorAll(selectors.steps);
      this.currentStepEl = this.querySelector(selectors.currentStepEl);
      this.prevButon = this.querySelector(selectors.prevButton);
      this.nextButon = this.querySelector(selectors.nextButton);
      this.progressBar = this.querySelector(selectors.progressBar);
      this.step1Value = null;
      this.step2Value = null;
      this.step1Items = this.querySelectorAll(selectors.step1Items);
      this.step2Items = this.querySelectorAll(selectors.step2Items);
      this.brideNameInput = this.querySelector(selectors.brideNameInput);
      this.createButton = this.querySelector(selectors.createButton);
      this.cancelModal = this.querySelector(selectors.cancelModal);
      this.cancelModalTrigger = this.querySelector(selectors.cancelModalTrigger);
      this.cancelModalSubmit = this.querySelector(selectors.cancelModalSubmit);
      this.modalClose = this.querySelectorAll(selectors.modalClose);
      this.quizPayload = {
        "title": this.brideNameInput.value,
        "weddingDate": "",
        "bridesmaidsQty": ""
      }

      this.handlePrev = this.handlePrev.bind(this);
      this.handleNext = this.handleNext.bind(this);

      this.init();
    }

    changeStep(step) {
      if (step > this.stepsCount || step < 1) return;

      this.currentStep = step;
      this.currentStepEl.textContent = step;

      this.steps.forEach(el => {
        const elStep = Number(el.getAttribute("data-step"));
        if (step === elStep) {
          el.classList.remove(selectors.hidden);
        } else {
          el.classList.add(selectors.hidden);
        }
      });

      switch (this.currentStep) {
        case 1:
          this.prevButon.classList.add(selectors.hidden);

          if (this.step1Value) {
            this.nextButon.classList.remove(selectors.hidden);
          } else {
            this.nextButon.classList.add(selectors.hidden);
          }

          break;
        case 2:
          if (this.step2Value) {
            this.nextButon.classList.remove(selectors.hidden);
          } else {
            this.nextButon.classList.add(selectors.hidden);
          }

          this.prevButon.classList.remove(selectors.hidden);

          break;
        case 3:
          this.nextButon.classList.add(selectors.hidden);
          this.prevButon.classList.remove(selectors.hidden);

          break;
        case 4:
          this.nextButon.classList.add(selectors.hidden);
          this.prevButon.classList.remove(selectors.hidden);

          this.quizPayload = {
            "title": this.brideNameInput.value,
            "bridesmaidsQty": this.step2Value,
            "weddingDate": this.querySelector(selectors.datePickerValue).value
          }

          window.localStorage.setItem("quizPayload", JSON.stringify(this.quizPayload));

          break;
      }
    }

    changeProgressBar() {
      this.progressBar.style.width = `${(100 / this.stepsCount) * this.currentStep}%`;
    }

    handlePrev() {
      this.changeStep(this.currentStep - 1);
      this.changeProgressBar();
      this.brideNameInput.value = "";
    }

    handleNext() {
      this.changeStep(this.currentStep + 1);
      this.changeProgressBar();
    }

    async handleCreateButton() {
      this.quizPayload = {
        "ownerName": window.customerFirstName,
        "ownerEmail": window.customerEmail,
        "title": this.brideNameInput.value,
        "bridesmaidsQty": this.step2Value,
        "weddingDate": this.querySelector(selectors.datePickerValue).value
      }

      window.localStorage.setItem("quizPayload", JSON.stringify(this.quizPayload));

      const data = await fetchShowroomApi(`/showrooms`, "POST", JSON.stringify(this.quizPayload));

      if (data) {
        window.localStorage.removeItem("quizPayload");
        window.localStorage.setItem("last_viewed_showroom", data.id);

        window.location = `/pages/showroom-event?id=${data.id}`
      }
    }

    openModal(el) {
      this.html.classList.add("overflow-hidden");
      el.classList.add("opened");
    }

    closeModal(el) {
      this.html.classList.remove("overflow-hidden");
      el.classList.remove("opened");
    }

    handleModalCloseOutside(e, modal) {
      const modalInner = modal.querySelector(selectors.modalInner);

      if (!modalInner.contains(e.target)) {
        this.closeModal(modal);
      }
    }

    init() {
      window.localStorage.removeItem("last_viewed_showroom");
      window.localStorage.removeItem("quizPayload");

      this.step1Items.forEach(item => item.addEventListener("click", () => {
        this.step1Items.forEach(el => el.classList.remove("active"));
        item.classList.add("active");
        this.step1Value = item.getAttribute("data-value");
        this.nextButon.classList.remove(selectors.hidden);
      }))

      this.step2Items.forEach(item => item.addEventListener("click", () => {
        this.step2Items.forEach(el => el.classList.remove("active"));
        item.classList.add("active");
        this.step2Value = item.getAttribute("data-value");
        this.nextButon.classList.remove(selectors.hidden);
      }))

      this.prevButon.addEventListener("click", this.handlePrev);
      this.nextButon.addEventListener("click", this.handleNext);

      this.brideNameInput.addEventListener("input", e => {
        if (e.target.value.length) {
          if (window.customerID) {
            this.createButton.classList.remove(selectors.disabled)
          } else {
            this.nextButon.classList.remove(selectors.hidden);
          }
        } else {
          if (window.customerID) {
            this.createButton.classList.add(selectors.disabled)
          } else {
            this.nextButon.classList.add(selectors.hidden);
          }
        }
      })

      this.createButton && this.createButton.addEventListener("click", this.handleCreateButton.bind(this));

      if (this.cancelModal) {
        this.cancelModalTrigger && this.cancelModalTrigger.addEventListener("click", () => this.openModal(this.cancelModal));
        this.cancelModal.addEventListener("click", e => this.handleModalCloseOutside(e, this.cancelModal));
        this.cancelModalSubmit.addEventListener("click", () => window.localStorage.removeItem("quizPayload"))

        this.modalClose && this.modalClose.forEach(el => el.addEventListener("click", () => this.closeModal(el.closest(selectors.modal))))
      }
    }
  }

  customElements.define(customElements.component, ShowroomQuiz);
}
